import {NextSeo} from "next-seo";
import {Header} from "@/components/Header";
import HeaderSimple from "@/components/HeaderSimple";
import {CallToAction} from "@/components/CallToAction";
import {Footer} from "@/components/Footer";
import {
    ArrowPathIcon,
    CloudArrowUpIcon,
    CurrencyEuroIcon,
    FingerPrintIcon,
    LockClosedIcon,
    ServerIcon
} from '@heroicons/react/20/solid'
import {CheckCircleIcon} from "@heroicons/react/24/solid";
import screenshotMarketplace from '@/images/screenshots/marketplace.png'
import Image from "next/image";
import {UserGroupIcon} from "@heroicons/react/24/solid/index";
import WhitepaperCta from "@/components/WhitepaperCta";
import girlsBookImage from '@/images/girls-book.jpeg'

const features = [
    {
        name: 'Netwerk',
        description:
            'Biedt toegang tot een netwerk met leerlingen die kunnen helpen met huiswerk en bijles\n',
        icon: UserGroupIcon,
    },
    {
        name: 'Financieel',
        description:
            'Afhankelijk van de keuzes van school is deze ondersteuning niet duur of zelfs gratis\n',
        icon: CurrencyEuroIcon,
    },
]

const benefits = [
    'het tarief is vele malen lager dan met een commerciële partij (als school kun je zelfs kiezen dit deels gratis aan te bieden)',
    'uit onderzoek is gebleken dat tutoring tussen leerlingen onderling veel effectiever is',
    'leerlingen die bijles geven doen waardevolle ervaring op',
    'als school heb je veel minder administratielast over de bijlessen, die tijd kun je besteden aan de kwaliteit van het onderwijs\n',
    'het is een kant-en-klaar platform, binnen 1 dag online'
];

export default function Kansenongelijkheid() {
    return (
        <>
            <NextSeo
                title="Kansenongelijkheid"
                description="Onze missie is: kansenongelijkheid verkleinen en zoveel mogelijk scholen hierbij helpen.
We denken écht dat we een simpele en effectieve oplossing hebben voor scholen."
            />
            <Header/>
            <main>
                <HeaderSimple
                    image={girlsBookImage}
                    title="Hoe Bijlesplein de kansenongelijkheid verkleint"
                    text="Onze missie is: kansenongelijkheid verkleinen en zoveel mogelijk scholen hierbij helpen.
We denken écht dat we een simpele, goedkope en effectieve oplossing hebben voor scholen. Het voelt een beetje in de categorie “Wij van WC-eend”. Want we zijn inderdaad een commerciële partij die haar product onder de aandacht brengt. Maar wel oprecht met de missie om de kansenongelijkheid in het onderwijs te verkleinen. Waarom dit belangrijk is en hoe Bijlesplein hier een bijdrage aan kan leveren, lees je hieronder. "
                />

                <figure className="mb-10 border-l border-blue-600 pl-9 max-w-xl mx-auto px-4">
                    <blockquote className="font-semibold text-gray-900 text-xl">
                        <p>
                            Kansenongelijkheid =
                            Leerlingen of studenten met dezelfde talenten krijgen niet dezelfde kansen.
                        </p>
                    </blockquote>
                </figure>

                <div
                    className="relative isolate overflow-hidden bg-white px-6 py-20 lg:overflow-visible lg:px-0">
                    <div
                        className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 lg:mx-0 lg:max-w-none lg:grid-cols-2 lg:items-start lg:gap-y-10">
                        <div
                            className="lg:col-span-2 lg:col-start-1 lg:row-start-1 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:grid-cols-2 lg:gap-x-8 lg:px-8">
                            <div className="lg:pr-4">
                                <div className="lg:max-w-lg">
                                    <h1 className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
                                        Oorzaken kansenongelijkheid
                                    </h1>
                                    <p className="mt-6 text-xl leading-8 text-gray-700">
                                        Er zijn meerdere oorzaken* die ervoor zorgen dat niet alle leerlingen dezelfde
                                        kansen krijgen in het onderwijs.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div
                            className="-ml-12 -mt-12 p-12 lg:sticky lg:top-20 lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:overflow-hidden">
                            <WhitepaperCta/>
                        </div>
                        <div
                            className="lg:col-span-2 lg:col-start-1 lg:row-start-2 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:grid-cols-2 lg:gap-x-8 lg:px-8">
                            <div className="lg:pr-4">
                                <div className="max-w-xl text-base leading-7 text-gray-700 lg:max-w-lg">
                                    <ul role="list" className="mt-8 space-y-8 text-gray-600">
                                        <li className="flex gap-x-3">
                                            <span>
                    <strong className="font-semibold text-gray-900">Invloed uit de samenleving.</strong> Bijvoorbeeld het onderwijssysteem waarbij wordt besloten welk onderwijsniveau een 12-jarige gaat volgen. Dat is soms te vroeg. Of dat kinderen uit dezelfde wijk met een vergelijkbare sociaaleconomische achtergrond bij elkaar in de klas komen. Vooral in kansarme wijken kan dit negatieve gevolgen hebben.
                  </span>
                                        </li>
                                        <li className="flex gap-x-3">
                                            <span>
                    <strong className="font-semibold text-gray-900">Invloed van school.</strong> In het Nederlandse onderwijssysteem overheersen de cultuur en normen van de middenklasse – en hogere klasse. Daardoor is het voor kinderen uit een lagere sociaaleconomische klasse vaak moeilijker om hun weg te vinden in het schoolsysteem. Bijvoorbeeld omdat zij thuis of van leeftijdsgenoten op straat andere regels hebben geleerd.
                  </span>
                                        </li>
                                        <li className="flex gap-x-3">
                                            <span>
                    <strong className="font-semibold text-gray-900">Invloed van kinderen zelf.</strong> De intelligentie, motivatie om te leren, gezondheid en het zelfvertrouwen van kinderen beïnvloeden hun kansen op school. Voor jongeren met een andere culturele achtergrond is dat soms moeilijker omdat zij verschillende culturele invloeden ervaren.
                  </span>
                                        </li>
                                        <li className="flex gap-x-3">
                                            <span>
                    <strong className="font-semibold text-gray-900">Mogelijkheden van ouders.</strong> Het hangt bijvoorbeeld af van hun onderwijsniveau, het netwerk en de steun die zij krijgen van vrienden en familie. Maar ook welke (financiële) mogelijkheden zij hebben om te helpen bij schoolwerk.
                  </span>
                                        </li>
                                        <li className="flex gap-x-3">
                                            <span>
                    <strong className="font-semibold text-gray-900">Samenhang tussen factoren.</strong> Bovenstaande factoren zijn van invloed op elkaar of hangen met elkaar samen. Het aanpakken van kansenongelijkheid in het onderwijs heeft daarom een integrale aanpak nodig.
                  </span>
                                        </li>
                                    </ul>
                                    {/*                      <p className="mt-8">*/}
                                    {/*                          Waar Bijlesplein een rol in kan spelen is het stuk waar ouders beperkte*/}
                                    {/*                          mogelijkheden hebben om hun kinderen te helpen. Bijlesplein:*/}
                                    {/*                      </p>*/}
                                    {/*                      <ul role="list" className="mt-8 max-w-xl space-y-8 text-gray-600">*/}
                                    {/*                          <li className="flex gap-x-3">*/}
                                    {/*                              <CheckCircleIcon className="mt-1 h-5 w-5 flex-none text-blue-600"*/}
                                    {/*                                               aria-hidden="true"/>*/}
                                    {/*                              <span>*/}
                                    {/*  Biedt toegang tot een netwerk met leerlingen die kunnen helpen met huiswerk*/}
                                    {/*                              en bijles*/}
                                    {/*</span>*/}
                                    {/*                          </li>*/}
                                    {/*                          <li className="flex gap-x-3">*/}
                                    {/*                              <CheckCircleIcon className="mt-1 h-5 w-5 flex-none text-blue-600"*/}
                                    {/*                                               aria-hidden="true"/>*/}
                                    {/*                              <span>*/}
                                    {/* Afhankelijk van de keuzes van school is deze ondersteuning niet duur of*/}
                                    {/*                              zelfs gratis*/}
                                    {/*</span>*/}
                                    {/*                          </li>*/}
                                    {/*                      </ul>*/}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div className="bg-white py-20 sm:py-20">
                    <div className="mx-auto max-w-7xl px-6 lg:px-8">
                        <div className="mx-auto max-w-2xl lg:text-center">
                            <p className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-3xl">
                                Waar Bijlesplein een rol in kan spelen is het stuk waar ouders beperkte
                                mogelijkheden hebben om hun kinderen te helpen. Bijlesplein:
                            </p>
                        </div>
                        <div className="mx-auto mt-16 max-w-2xl sm:mt-20 lg:mt-24 lg:max-w-4xl">
                            <dl className="grid max-w-xl grid-cols-1 gap-x-8 gap-y-10 lg:max-w-none lg:grid-cols-2 lg:gap-y-16">
                                {features.map((feature) => (
                                    <div key={feature.name} className="relative pl-16">
                                        <dt className="text-base font-semibold leading-7 text-gray-900">
                                            <div
                                                className="absolute left-0 top-0 flex h-10 w-10 items-center justify-center rounded-lg bg-blue-600">
                                                <feature.icon className="h-6 w-6 text-white" aria-hidden="true"/>
                                            </div>
                                            {feature.name}
                                        </dt>
                                        <dd className="mt-2 text-base leading-7 text-gray-600">{feature.description}</dd>
                                    </div>
                                ))}
                            </dl>
                        </div>
                    </div>
                </div>


                <div className="mx-auto max-w-3xl text-base leading-7 text-gray-700">

                    <div className="mt-10 max-w-2xl">
                        <h2 className="text-2xl font-bold tracking-tight text-gray-900">
                            Bied gratis of tegen een laag tarief bijles aan tussen leerlingen onderling
                        </h2>
                        <p className="mt-6">
                            We begrijpen dat je als onderwijsinstelling kiest voor commerciële bijlesaanbieders. Want
                            ja, je zit al krap in je capaciteit. Maar, niet alle ouders kunnen dat betalen. Terwijl je
                            als school ook verantwoordelijkheid hebt als het gaat om kansenongelijkheid. Het kan anders.
                        </p>

                        <p className="mt-8">
                            Wat nou als je een platform hebt waarbij je vraag en aanbod van bijles tussen leerlingen
                            onderling samenbrengt. Leerlingen die bijles willen, zoeken een medeleerling die deze les
                            aanbiedt.
                        </p>

                        <h2 className="text-2xl font-bold tracking-tight text-gray-900 mt-8">
                            Dat heeft 5 belangrijke voordelen:
                        </h2>

                        <ul role="list" className="mt-6 max-w-xl space-y-2 text-gray-600">
                            {benefits.map((benefit, index) =>
                                <li key={index} className="flex gap-x-3">
                                    <CheckCircleIcon className="mt-1 h-5 w-5 flex-none text-blue-600"
                                                     aria-hidden="true"/>
                                    <span>{benefit}</span>
                                </li>
                            )}
                        </ul>

                        <p className="mt-8">
                            Wil je meer weten over hoe het werkt en hoe bijdraagt aan kansengelijkheid? Neem contact met
                            ons op.
                        </p>

                        <p className="mt-8 text-sm opacity-70 mb-8">
                            *Bron: Nederlands Jeugdinstituut
                        </p>

                    </div>
                </div>

                <CallToAction/>
            </main>
            <Footer/>
        </>
    )
}
